/**
 * When enter is pressed, this will split the block and set the second block
 * to `defaultBlock`.
 */
export default ({ defaultBlock = "paragraph" }) => ({
  commands: {
    resetBlock(editor) {
      editor.splitBlock().setBlocks(defaultBlock)
    }
  },
  onKeyDown(event, editor, next) {
    if (event.key !== "Enter") return next()

    return editor.resetBlock().removeFontSize()
  }
})
